import { atom } from 'jotai'
import { IntegrationServices } from '@sequencehq/api'
import { createFieldAtom } from '../../common/atoms'
import { DEFAULT_QUANTITY, DEFAULT_RATE_DISPLAY } from '../../constants'
import { RateDisplay } from 'Invoices/types'

export type FormState = {
  title: string
  quantity: string
  rate: string
  descriptionEnabled: boolean
  description: string
  rateDisplay: RateDisplay
  externalIds: Array<{ key: IntegrationServices; value: string }>
}

export const INITIAL_STATE: FormState = {
  title: '',
  quantity: DEFAULT_QUANTITY,
  rate: '',
  descriptionEnabled: false,
  description: '',
  rateDisplay: DEFAULT_RATE_DISPLAY,
  externalIds: []
}

export const formStateAtom = atom<FormState>(INITIAL_STATE)

export const titleAtom = createFieldAtom(formStateAtom, 'title')
export const quantityAtom = createFieldAtom(formStateAtom, 'quantity')
export const rateAtom = createFieldAtom(formStateAtom, 'rate')
export const descriptionEnabledAtom = createFieldAtom(
  formStateAtom,
  'descriptionEnabled'
)
export const descriptionAtom = createFieldAtom(formStateAtom, 'description')
export const rateDisplayAtom = createFieldAtom(formStateAtom, 'rateDisplay')
export const externalIdsAtom = createFieldAtom(formStateAtom, 'externalIds')
